<template>
  <div>
    <el-form ref="user-bind-form" :model="bind" size="small">
      <el-form-item prop="mobile" :rules="[{validator: mobileValidate}]">
        <el-input v-model="bind.mobile" placeholder="请填写手机号进行绑定"></el-input>
      </el-form-item>
      <el-form-item class="text-center">
        <el-button type="primary" @click="doBind">绑定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import WeChatService from "@/services/user/WeChatService";
import User from "@/models/User";

const regx = /1[0-9]{11}/g

export default {
  name: "UserBindForm",
  props: {
    openId: String
  },
  data() {
    return {
      bind: {
        mobile: ''
      }
    }
  },
  methods: {
    mobileValidate(r, v, cb) {
      if (!regx.match(v)) {
        return cb(new Error("请输入正确的手机号"))
      }
      return cb()
    },
    doBind() {
      this.$refs['user-bind-form'].validate(valid => {
        if (valid) {
          WeChatService.binding(this.openId, this.mobile).then(resp => {
            if (resp.status === 200) {
              const user = new User(resp.data);
              if (user.isLogined()) {
                this.$router.push("/")
              } else {
                this.$message.warning(resp.data.message)
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
